module.exports = __webpack_public_path__ + "img/untitled(81).5ffdccce.png";